"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CuratedForYouHero() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222869" id="crust-artisan-bakery" className="relative w-full bg-background overflow-hidden py-24 lg:py-32 xl:py-40">
      {}
      
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 items-center">
          
          {}
          <div ref={leftRef} className={`lg:col-span-7 flex flex-col gap-8 z-10 transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] xl:text-[6.5rem] font-bold font-serif leading-[1.05] tracking-tighter text-foreground">
              The Soul of <br className="hidden md:block" />
              <span className="text-primary">Sourdough.</span>
            </h1>
            
            <p className="font-default text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
              CRUST Artisan Bakery. Discover our handcrafted selection of golden loaves and delicate pastries, baked with time-honored techniques and premium local ingredients.
            </p>
            
            <div className="flex items-center gap-4 pt-4">
              <Link to="#">
                <Button size="lg" className="h-14 px-8 text-base rounded-full shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/40 hover:bg-accent hover:text-accent-foreground hover:-translate-y-0.5 transition-all duration-300 bg-primary text-primary-foreground">
                  Shop the Daily Batch
                  <ArrowRight className="ml-2 size-5" />
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-5 relative z-0 transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}>
            <div className="relative w-full max-w-md mx-auto lg:ml-auto aspect-[4/5] lg:aspect-[3/4]">
              
              {}
              <div className="absolute inset-0 bg-secondary rounded-[2rem] transform rotate-3 scale-105 transition-transform duration-1000 hover:rotate-6 shadow-inner"></div>
              
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645038/img/lifestyle_nomad_main.png" alt="Freshly Baked Sourdough" className="absolute inset-0 w-full h-full object-cover rounded-2xl shadow-2xl shadow-foreground/10 z-10 transition-transform duration-700 hover:scale-[1.02]" />
              
              {}
              <div className="absolute -bottom-8 -left-8 w-44 aspect-square z-20">
                <div className="relative w-full h-full">
                  <div className="absolute inset-0 bg-background/20 rounded-xl blur-md transform translate-y-4"></div>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645038/img/accessory_detail_watch.png" alt="Artisan Detail" className="relative w-full h-full object-cover rounded-xl shadow-xl border border-background/50 transition-transform duration-500 hover:-translate-y-2" />
                </div>
              </div>

              {}
              <div className="absolute top-12 -right-6 z-30 bg-background/80 backdrop-blur-md px-6 py-4 rounded-2xl shadow-xl border border-border/50 animate-pulse" style={{
              animationDuration: '4s'
            }}>
                <div className="flex items-center gap-3">
                  <div className="size-2 rounded-full bg-primary animate-ping"></div>
                  <p className="font-default text-sm font-medium text-foreground">Baked at 4AM. Delivered by 9AM.</p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>;
}